export default __webpack_public_path__ + "static/SR - Global Company Brochure-38ecec4897a3184dcfad91a061cf5343.pdf";